module.exports = __webpack_public_path__ + "6885d573018aa34891126d17be1b2e94.jpg";